<template lang='pug'>
v-expansion-panel
    v-expansion-panel-content
      div(slot='header')
        span(class='subheading')
          | Записавшиеся клиенты
      v-list(two-line)
        v-list-tile(
          v-for='assign in orderBy(assigns, "client_name")'
          :key='assign.id'
          avatar
          @click='$emit("click", assign)'
        )
          v-list-tile-avatar
            v-icon(class='primary white--text') person
          v-list-tile-content
            v-list-tile-title {{ assign.client_name }}
            v-list-tile-sub-title Тел. {{ assign.client_phone | phone }}
</template>

<script>
export default {
  props: {
    assigns: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>
